module.exports = __webpack_public_path__ + "media/images/farey/social/Facebook-6edb5173757836bf082de7ee324fe7a2.png";